import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";

import { AuthProvider, useAuth } from "@/lib/auth-context";
import { SessionRefreshIndicator } from "@/components/providers/SessionRefreshIndicator";
import { ThemeProvider } from "./lib/theme-context";
import { Toaster } from "./components/ui/sonner";
import { router } from "./Router";

window.addEventListener("vite:preloadError", () => {
  // Evita loop de reload quando o chunk realmente não existe mais (ex.: asset
  // removido em deploy). Recarrega no máximo uma vez por sessão.
  if (sessionStorage.getItem("vite-preload-reloaded")) return;
  sessionStorage.setItem("vite-preload-reloaded", "1");
  window.location.reload();
});

window.addEventListener("load", () => {
  sessionStorage.removeItem("vite-preload-reloaded");
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export default function App() {
  return (
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider defaultTheme="light" storageKey="@workflow-theme">
          <AppContent />
        </ThemeProvider>
      </QueryClientProvider>
    </AuthProvider>
  );
}

function AppContent() {
  const { isRehydrating } = useAuth();
  return (
    <>
      <Toaster position="top-right" richColors />
      <RouterProvider router={router} />
      <SessionRefreshIndicator initialCheck={isRehydrating} />
    </>
  );
}
